import { ProductBookingLine } from 'Components/lines/product-booking-line/ProductBookingLine';
export default ProductBookingLine;
